module.exports = __webpack_public_path__ + "static/media/urupes.1983f120.webp";